import { render, staticRenderFns } from "./AppLoader.vue?vue&type=template&id=23682ff6&scoped=true&"
import script from "./AppLoader.vue?vue&type=script&lang=js&"
export * from "./AppLoader.vue?vue&type=script&lang=js&"
import style0 from "./AppLoader.vue?vue&type=style&index=0&id=23682ff6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23682ff6",
  null
  
)

export default component.exports